import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import { organizationSchema, websiteSchema, breadcrumbSchema, faqSchema } from "@/lib/seoData";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import AnimeShowcase from "./components/AnimeShowcase";
import GuomanFeature from "./components/GuomanFeature";
import ArticleSection from "./components/ArticleSection";
import Faq from "./components/Faq";

const faqList = [
  {
    question: "动漫网的动漫列表多久更新一次？",
    answer: "动漫网会持续同步新番索引与连载作品信息，每季新番上线前后都会及时更新，确保用户能看到最新的全部动漫列表与状态。",
  },
  {
    question: "如何在动漫网快速找到想看的动漫？",
    answer: "你可以通过顶部的检索入口进入全部动漫页面，再根据国漫、日漫、热血、治愈等漫画分类大全进行筛选，快速锁定目标作品。",
  },
  {
    question: "动漫网支持国漫和日漫检索吗？",
    answer: "支持。动漫网专门设有国漫专区与日漫检索入口，配合动画库，让你在找漫画、追更新时一站搞定。",
  },
];

const jsonLd = [
  organizationSchema,
  websiteSchema,
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "动漫网 - 动漫网全部动漫列表 / 动漫网新番索引，漫画分类大全与国漫日漫检索入口",
    description: "这里是动漫网全站资源聚合检索入口，新番索引、漫画分类大全、国漫专区、日漫检索、动画库一站配齐。",
    url: "https://comicdex.github.io/",
    inLanguage: "zh-CN",
    isPartOf: websiteSchema,
  },
  breadcrumbSchema([{ name: "首页", path: "/" }]),
  faqSchema(faqList),
];

export default function Home() {
  return (
    <Layout>
      <Seo
        title="动漫网 - 动漫网全部动漫列表 / 动漫网新番索引，漫画分类大全与国漫日漫检索入口"
        description="这里是动漫网全站资源聚合检索入口，点开直接看到动漫网全部动漫列表，新番索引、漫画分类大全、国漫专区、日漫检索、动画库一站配齐，找漫画、追更新不用再翻来翻去。"
        keywords="动漫网,动漫网全部动漫列表,动漫网新番索引,动漫网漫画分类大全,动漫网国漫专区,动漫网日漫检索,动漫网动画库"
        canonical="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <CategoryGrid />
      <AnimeShowcase />
      <GuomanFeature />
      <ArticleSection />
      <Faq />
    </Layout>
  );
}